// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"782":"2be87c3e","800":"117b80d1","987":"d4eca1d0"}[chunkId] + ".css";
};